import {getStore, setStore} from '@/util/store'
import {loginByUsername, logout, refreshToken, LoginByShow} from '@/plugins/api/login'
import {aesEncrypt} from '@/util/encryption'
import webiste from '@/const/website'
import {getPermission} from "../plugins/api/loginApi";
import {Message} from 'element-ui'

const user = {
  state: {
    userInfo: getStore({
      name: 'userInfo'
    }) || {},
    permissions: getStore({
      name: 'permissions'
    }) || [],
    roles: [],
    access_token: getStore({
      name: 'access_token'
    }) || '',
    refresh_token: getStore({
      name: 'refresh_token'
    }) || '',
    current_site: getStore({
      name: 'current_site'
    }) || {},
  },
  actions: {
    // 根据用户名登录
    LoginByUsername({commit}, userInfo) {
      if (webiste.passwordEnc) {
        userInfo.password = aesEncrypt(userInfo.password, webiste.encPassword)
      }
      return new Promise((resolve, reject) => {
        loginByUsername(userInfo.username, userInfo.password, userInfo.code, userInfo.randomStr).then(response => {
          commit('SET_ACCESS_TOKEN', response.access_token)
          commit('SET_REFRESH_TOKEN', response.refresh_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 根据用户名登录
    LoginByShow({commit}) {
      const userInfo = {
        username: 'outerlink',
        password: 'Tw7cie8HSH2HHWaX'
      }

      return new Promise((resolve, reject) => {
        LoginByShow(userInfo.username, userInfo.password).then(response => {
          commit('SET_ACCESS_TOKEN', response.access_token)
          commit('SET_REFRESH_TOKEN', response.refresh_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 刷新token
    RefreshToken({commit, state}) {
      return new Promise((resolve, reject) => {
        refreshToken(state.refresh_token).then(response => {
          const data = response.data
          commit('SET_ACCESS_TOKEN', data.access_token)
          commit('SET_REFRESH_TOKEN', data.refresh_token)

          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询用户信息
    GetUserInfo({commit, state}, site) {

      // return new Promise((resolve, reject) => {
      //   getPermission().then((res) => {
      //     if (res.code === 0) {
      //       const data = res.data || {}
      //       commit('SET_PERMISSIONS', data || [])
      //       const list = {}
      //       for (let i = 0; i < data.length; i++) {
      //         list[data[i].system_from] = data[i].data_permission
      //       }
      //       if (!list[site] || list[site][0] == {}) {
      //         commit('SET_ACCESS_TOKEN', '')
      //         commit('SET_REFRESH_TOKEN', '')
      //         Message.error('暂无权限，请联系管理员配置权限！')
      //         reject()
      //       }
      //       let obj = getStore({name: 'current_site'}) || {}
      //       if (obj && obj.id) {
      //         // console.log('====1====', obj.id)
      //         //当前列表不存在（1、切换站点导致的，2、后台数据权限关掉了）
      //         const index = list[site].findIndex(v => v.id === obj.id)
      //         if (index === -1) {
      //           obj = list[site][0] || {}
      //         }
      //       } else {
      //         obj = list[site][0] || {}
      //       }
      //       //默认第一个
      //       commit('SET_CURRENT_SITE', obj)
      //     }

      //     resolve(res)
      //   }).catch((err) => {
      //     reject(err)
      //   })
      // })
    },
    // 登出
    LogOut({commit}) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_PERMISSIONS', [])
          commit('SET_ACCESS_TOKEN', '')
          commit('SET_REFRESH_TOKEN', '')

          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 注销session
    FedLogOut({commit}) {
      return new Promise(resolve => {
        commit('SET_PERMISSIONS', [])
        commit('SET_ACCESS_TOKEN', '')
        commit('SET_REFRESH_TOKEN', '')
        resolve()
      })
    },
  },
  getters: {
    permissions: state => state.permissions,
    current_site: state => state.current_site,
  },
  mutations: {
    SET_ACCESS_TOKEN: (state, access_token) => {
      state.access_token = access_token
      setStore({
        name: 'access_token',
        content: state.access_token,
        // type: 'session'
      })
    },
    SET_REFRESH_TOKEN: (state, rfToken) => {
      state.refresh_token = rfToken
      setStore({
        name: 'refresh_token',
        content: state.refresh_token,
        // type: 'session'
      })
    },
    SET_CURRENT_SITE: (state, obj) => {
      state.current_site = obj
      setStore({
        name: 'current_site',
        content: obj,
        // type: 'session'
      })
    },
    SET_PERMISSIONS: (state, permissions) => {
      const list = {}
      for (let i = 0; i < permissions.length; i++) {
        list[permissions[i].system_from] = permissions[i].data_permission
      }
      state.permissions = list
      setStore({
        name: 'permissions',
        content: list,
        // type: 'session'
      })
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/userStore.js